/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:9fb53a1b-29e3-4620-9167-9c0c81bf007a",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_irfsjmbz6",
    "aws_user_pools_web_client_id": "6g7an3i6cj10417l7gf2o0f46h",
    "oauth": {}
};


export default awsmobile;
